export enum EEquipmentType {
  RX,
  Fan,
  Rake,
  Pad,
  Encapsulate,
  Info_Form,
}
